<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                "
              >
                <div class="card-heading">
                  <h4>Scan QR Code</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>
              <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6 mt-5 mb-5">
                  <div class="upload m-3" >
                    <div class="sub d-flex flex-column">
                      <label class="ml-auto mr-auto" for="upload-img">
                        <i class="fas fa-cloud-upload-alt">Upload</i>
                        </label>
                        <p class="text-center mb-0">Png or Jpeg file required</p>
                        <!-- <p class="text-center">Document Name</p> -->
          
                        <input
                        type="file"
                        accept=".png, .jpeg, .jpg"
                        class="form-control-file" 
                        id="upload-img"
                        style="display: none"
                        />
                      </div>
                      
                    </div>
                </div>

              </div>
              <div class="col-lg-12">
                <div class="form-group text-center mt-4">
                  <button type="submit mt-5 mb-5" (click)="viewModal(resultModal)" class="theme_btn tp_two logo-button-website">Verify</button>
                  <button type="button" (click)="viewModal(resultModal)" id="loadPiositiveModal"
                    class="d-none" >
                  </button>  
                </div>
              </div>                     
 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template let-modal #resultModal>
  <!-- Modal -->
  <div class=" bg-success"  >
    <div class="m">
      <div class="modal-content">
        <div class="modal-header-custom">
          <!-- <h5 class="modal-title" id="exampleModalLongTitle">Update Record</h5> -->
          <button type="button" class="float-right" (click)="modal.close('Save click')">
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
        <div class=" bg-success ">
          <div class=" container-fluid ">
            <div class="col-md-12 justify-content-end d-flex">
              <button class=" theme_btn tp_two logo-button-website">Print <i class="fas fa-print"></i></button>
            </div>
            <div class="row">
                 <div class="col-md-12 pt-3 ">
                    <div class="text-center">
                        <h2>COVID-19 Positive</h2>
                         <div class=" py-3 px-5 border bg-white mb-4" style="border-radius: 7px; ">
                           For flight to Ghana
                         </div>
                    </div>
                </div>
            </div>
            <div class="ml-4 pl-4">
              <tr>
                <td  class="font-13">
                  <strong>Valid Till: Feb 4, 2022</strong>
                </td>
                <td  class="pl-5 font-13">
                  <strong>Sample Collection date: Feb 4, 2021</strong>
                </td>
              </tr>

            </div>

           </div>
           <div class="border-bottom-inbound "></div>
            <div class="container-fluid font-12">
                <div class="row">
                    <div class="col-lg-12 ml-5 mt-4 pl-5"> 
                           
                            <tr class="pl-5">
                                <td><strong>

                                  Passenger's Name: 	<br>		
                                  Passport Number: <br>										
                                  Laboratory Name: <br>										   
                                    Date of Birth: 		<br>
                                    Status: <br> 
                                  </strong>
                                </td>

                                <td colspan="4" class="ml-5 pl-5">
                                  <strong>

                                    Jane Doe<br>
                                    AS32456789765433 <br>
                                    ABC Lab <br>
                                    March 2nd 1995 <br>
                                    Valid <br>
                                  </strong>
                                    

                                </td>
                                
                            </tr> 

                    </div> 
                </div>

                <div class=" text-center mt-5 mb-5">
                  <b>Action : This result is</b><br>
                  <div class="">
                    <button class="theme_btn tp_two logo-button-website">Authentic</button>
                    <button class="theme_btn tp_two logo-button-website ml-3">Forged</button>
                  </div><br>
                  <div>
                    <button class="scan-button" type="button" (click)="modal.close('Save click')">Scan Next Result</button>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>

<ng-template let-modal #invalidModal>
  <!-- Modal -->
  <div class=" bg-danger"  >
    <div class="m">
      <div class="modal-content">
        <div class="modal-header-custom">
          <!-- <h5 class="modal-title" id="exampleModalLongTitle">Update Record</h5> -->
          <button type="button" class="float-right" (click)="modal.close('Save click')">
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
        <div class=" bg-danger ">
          <div class=" container-fluid ">
             
            <div class="container-fluid font-13">
                 
                <div class=" text-center mt-5 mb-5">
                  <b>Action : This result is</b><br>
                  <div class="">
                    <button class="btn btn-primary">Authentic</button>
                    <button class="btn btn-primary ml-3">Forged</button>
                  </div><br>
                  <div>
                    <button class="btn btn-secondary" type="button" (click)="modal.close('Save click')">Scan Next Result</button>
                  </div>
                </div>
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>